import React, {useState} from "react";
import {BotChatDialog} from "./BotChatDialog";
import {WidgetBubbleContainer} from "./WidgetBubbleContainer";
import {useAppSelector} from "../../app/hooks";
import {
    isBotOpenSelector, welcomeBubbleOpenSelector
} from "../chatbotSlice";
import {BUBBLE_HEIGHT, BUBBLE_WITH_STARTERS_HEIGHT} from "./App/App";

interface LiveChatProps {
    resizeWidget: (width: string, height: string) => void;
}

export const LiveChat: React.FC<LiveChatProps> = ({resizeWidget}) => {
    const isBubbleContentVisible = useAppSelector(welcomeBubbleOpenSelector)
    const [height, setHeight] = useState(isBubbleContentVisible ? BUBBLE_WITH_STARTERS_HEIGHT : BUBBLE_HEIGHT)
    const isBotOpen = useAppSelector(isBotOpenSelector)

    const handleResizeWidget = (width: string, height: string) => {
        setHeight(height)
        resizeWidget(width, height)
    }

    return <div className="relative w-full flex justify-center" style={{height: height}}>
        {!isBotOpen && <WidgetBubbleContainer
            resizeWidget={handleResizeWidget}/>}
        <BotChatDialog/>
    </div>
}
